"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactLeaflet = require("react-leaflet");

require("leaflet/dist/leaflet.css");

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

require("@identitybuilding/idb-react-ui-elements/dist/styles/Colors.css");

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

require("./Style.css");

var _Sidebar = require("./components/Sidebar");

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _leaflet = require("leaflet");

var _leaflet2 = _interopRequireDefault(_leaflet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mijn_stad_gemeente_municipalitiesData = require("../public/data/mijn-stad-gemeente_municipalities.min.json");
// const catalogus_municipalitiesData = require("../public/data/catalogus-municipalities.min.json");
var municipalitiesData = require("../public/data/municipalities.min.json");
var sub_MunicipalitiesData = require("../public/data/sub_municipalities.min.json");
var countryData = require("../public/data/country.min.json");
var provincesData = require("../public/data/provinces.min.json");
var regionsData = require("../public/data/regions.min.json");

var MyMap = function MyMap(props) {
  var _useState = (0, _react.useState)([{ name: 'regions', active: false, loaded: false }, { name: 'provinces', active: true, loaded: true }, { name: 'districts', active: false, loaded: false }, { name: 'municipalities', active: true, loaded: true }, { name: 'sub_municipalities', active: false, loaded: false }]),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      borders = _useState2[0],
      setBorders = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      country = _useState4[0],
      setCountry = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      current = _useState6[0],
      setCurrent = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = (0, _slicedToArray3.default)(_useState7, 2),
      regions = _useState8[0],
      setRegions = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = (0, _slicedToArray3.default)(_useState9, 2),
      provinces = _useState10[0],
      setProvinces = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = (0, _slicedToArray3.default)(_useState11, 2),
      arrondissementen = _useState12[0],
      setArrondissementen = _useState12[1];

  var _useState13 = (0, _react.useState)(""),
      _useState14 = (0, _slicedToArray3.default)(_useState13, 2),
      municipalities = _useState14[0],
      setMunicipalities = _useState14[1];

  var _useState15 = (0, _react.useState)(""),
      _useState16 = (0, _slicedToArray3.default)(_useState15, 2),
      subMunicipalities = _useState16[0],
      setSubMunicipalities = _useState16[1];

  var _useState17 = (0, _react.useState)(false),
      _useState18 = (0, _slicedToArray3.default)(_useState17, 2),
      baseLayer = _useState18[0],
      _setBaseLayer = _useState18[1];

  var _useState19 = (0, _react.useState)(true),
      _useState20 = (0, _slicedToArray3.default)(_useState19, 2),
      baseNames = _useState20[0],
      _setBaseNames = _useState20[1];

  var _useState21 = (0, _react.useState)(false),
      _useState22 = (0, _slicedToArray3.default)(_useState21, 2),
      baseUrl = _useState22[0],
      setBaseUrl = _useState22[1];

  var _useState23 = (0, _react.useState)(true),
      _useState24 = (0, _slicedToArray3.default)(_useState23, 2),
      showSidebar = _useState24[0],
      setShowSidebar = _useState24[1];

  var _props$followingMunic = props.followingMunicipalities,
      followingMunicipalities = _props$followingMunic === undefined ? [] : _props$followingMunic;

  var _useState25 = (0, _react.useState)(true),
      _useState26 = (0, _slicedToArray3.default)(_useState25, 2),
      loading = _useState26[0],
      setLoading = _useState26[1]; // State to track loading


  var _useState27 = (0, _react.useState)(false),
      _useState28 = (0, _slicedToArray3.default)(_useState27, 2),
      nisCodeLoaded = _useState28[0],
      setNisCodeLoaded = _useState28[1]; // Track if NIS code is loaded


  var _useState29 = (0, _react.useState)([]),
      _useState30 = (0, _slicedToArray3.default)(_useState29, 2),
      activeMunicipalities = _useState30[0],
      setActiveMunicipalities = _useState30[1];

  // Diffrent styles for each NIS layer(s)


  var countryStyle = {
    style: { fillColor: "var(--grey-100)", fillOpacity: 0.1, color: "var(--main)", weight: 3, className: 'country' }
  };
  var catalogus_countryStyle = {
    style: { fillColor: "var(--grey-100)", fillOpacity: 0.1, color: "var(--cn)", weight: 3, className: 'country' }
  };
  var regionStyle = {
    style: { fillColor: "none", fillOpacity: 1, color: "var(--grey-80)", weight: 3, className: 'regions' }
  };
  var provinceStyle = {
    style: { fillColor: "none", fillOpacity: 0, color: "var(--sub)", weight: 2, className: 'provinces' }
  };
  var catalogus_provinceStyle = {
    style: { fillColor: "none", fillOpacity: 0, color: "var(--wordpress)", weight: 2, className: 'provinces' }
  };
  var arrondissementenStyle = {
    style: { fillColor: "none", fillOpacity: 0, color: "var(--grey-80)", weight: 1.5, className: 'districts' }
  };
  var municialityStyle = {
    style: { fillColor: "var(--grey-50)", fillOpacity: 0.2, color: "var(--grey-50)", weight: 1, className: 'municipalities' },
    style_hover: { fillColor: "var(--grey-70)", fillOpacity: 0.5, color: "var(--grey-50)", weight: 1 },
    style_active: { fillColor: "var(--main)", fillOpacity: 0.75, color: "var(--grey-50)", weight: 2 },
    style_active_hover: { fillColor: "var(--main)", fillOpacity: 0.5, color: "var(--grey-50)", weight: 2 }
  };
  var catalogus_municialityStyle = {
    style: { fillColor: "var(--grey-50)", fillOpacity: 0.2, color: "var(--grey-50)", weight: 1, className: 'municipalities' },
    style_hover: { fillColor: "var(--grey-70)", fillOpacity: 0.5, color: "var(--grey-50)", weight: 1 },
    style_active: { fillColor: "var(--cn)", fillOpacity: 0.75, color: "var(--cn)", weight: 2 },
    style_active_hover: { fillColor: "var(--cn)", fillOpacity: 0.5, color: "var(--cn)", weight: 2 }
  };
  var stad_gemeenteStyle = {
    style: { fillColor: "var(--grey-50)", fillOpacity: 0.2, color: "var(--grey-50)", weight: 1, className: 'municipalities' },
    style_hover: { fillColor: "var(--grey-70)", fillOpacity: 0.5, color: "var(--grey-50)", weight: 1 },
    style_active: { fillColor: "#8CD0F2", fillOpacity: 0.75, color: "#8CD0F2", weight: 2 },
    style_active_hover: { fillColor: "var(--cn)", fillOpacity: 0.5, color: "var(--cn)", weight: 2 }
  };
  var submunicialityStyle = {
    style: { fillColor: "transparent", fillOpacity: 0, color: "var(--grey-50)", weight: 1, className: 'sub_municipalities' }
  };

  var mapRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    getInitialData();
    return function () {};
  }, []);

  // Existing logic with fetching data from API

  // Let country and the municipalities load in first
  // const getInitialData = async () => {
  //   try {
  //     await axios.get(`https://o-sn.be/kml/belgium/${props.type === 'vlaanderen' ? 'regions' : 'country'}.min.json`)
  //       .then((res) => {
  //         let new_object = {
  //           type: "FeatureCollection",
  //           features: res.data.features.filter(
  //             feature => feature.properties.NIS_code === '04000' || feature.properties.NIS_code === '02000')
  //         }
  //         if (props.type === 'vlaanderen') {
  //           setCountry(new_object)
  //         }
  //         else {
  //           setCountry(res.data)
  //         }
  //         let newParent = document.getElementById('custom-map-controls');
  //         let oldParent = document.getElementsByClassName("leaflet-bottom leaflet-left")[0]; // Access the first element
  //         if (oldParent && oldParent.childNodes.length > 0) {
  //           while (oldParent.childNodes.length > 0) {
  //             newParent.appendChild(oldParent.childNodes[0]);
  //           }
  //         }

  //       })
  //     let muni_url = props.MyCity ? "https://o-sn.be/kml/belgium/catalogus-municipalities.min.json" : "https://o-sn.be/kml/belgium/municipalities.min.json"
  //     await axios.get(muni_url)
  //       .then((res) => {
  //         // for localhost
  //         let new_object = {
  //           type: "FeatureCollection",
  //           features: res.data.features.filter(
  //             feature =>
  //               feature.properties.NIS_3 === 'Limburg' || feature.properties.NIS_3 === 'Oost-Vlaanderen'
  //               || feature.properties.NIS_3 === 'West-Vlaanderen' || feature.properties.NIS_3 === 'Vlaams-Brabant'
  //               || feature.properties.NIS_3 === 'Antwerpen' || feature.properties.NIS_3 === 'Brussels Hoofdstedelijk Gewest'
  //           )
  //         }


  //         if (props.type === 'vlaanderen') {
  //           setMunicipalities(new_object)
  //         }
  //         else {
  //           setMunicipalities(res.data)
  //         }

  //       })
  //     await axios.get('https://o-sn.be/kml/belgium/provinces.min.json')
  //       .then((res) => {
  //         let new_object = {
  //           type: "FeatureCollection",
  //           features: res.data.features.filter(
  //             feature =>
  //               feature.properties.NameNL === 'Limburg' || feature.properties.NameNL === 'Oost-Vlaanderen'
  //               || feature.properties.NameNL === 'West-Vlaanderen' || feature.properties.NameNL === 'Vlaams-Brabant'
  //               || feature.properties.NameNL === 'Antwerpen' || feature.properties.NameNL === 'Brussels Hoofdstedelijk Gewest'
  //           )
  //         }
  //         if (props.type === 'vlaanderen') {
  //           setProvinces(new_object)
  //         }
  //         else {
  //           setProvinces(res.data)
  //         }
  //       });

  //   } catch (error) {
  //     console.error("Error loading data:", error);
  //   } finally {
  //     setLoading(false); // Set loading to false after data is loaded
  //   }
  //   // Get dat with API from Oele
  //   // // await axios.get(`https://api.ondernemersnetwerk.be/location/municipality/BE72003`)
  //   //   await axios.get('https://api.ondernemersnetwerk.be/location/municipality/all?ids')
  //   //   .then(async (res) => {
  //   //     for (let i = 0; i < res.data.length; i++) {
  //   //       let id = res.data[i].id
  //   //       await axios.get(`https://api.ondernemersnetwerk.be/location/municipality/${id}`)
  //   //         .then((response) => {
  //   //           let layer = L.GeoJSON.geometryToLayer(response.data.geoms)
  //   //           layer.setStyle(municialityStyle.style)
  //   //           layer.bindPopup(response.data.name)
  //   //           mapRef.current.leafletElement.addLayer(layer)
  //   //         })
  //   //     }
  //   //   })
  // };


  // New logic with fetching data from local files
  var getInitialData = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var countryDataFiltered, municipalitiesFiltered, _activeMunicipalities, provincesFiltered;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                countryDataFiltered = {
                  type: "FeatureCollection",
                  features: countryData.features.filter(function (feature) {
                    return feature.properties.NIS_code === '04000' || feature.properties.NIS_code === '02000';
                  })
                };

                if (props.type === 'vlaanderen') {
                  setCountry(countryDataFiltered);
                } else {
                  setCountry(countryData);
                }

                municipalitiesFiltered = {
                  type: "FeatureCollection",
                  features: (props.MyCity ? mijn_stad_gemeente_municipalitiesData : municipalitiesData).features.filter(function (feature) {
                    return feature.properties.NIS_3 === 'Limburg' || feature.properties.NIS_3 === 'Oost-Vlaanderen' || feature.properties.NIS_3 === 'West-Vlaanderen' || feature.properties.NIS_3 === 'Vlaams-Brabant' || feature.properties.NIS_3 === 'Antwerpen' || feature.properties.NIS_3 === 'Brussels Hoofdstedelijk Gewest';
                  })
                };
                _activeMunicipalities = municipalitiesFiltered.features.filter(function (feature) {
                  return feature.properties.active === 'true';
                }) // Filter active ones
                .map(function (feature) {
                  return feature.properties.NameNL;
                }); // Get only their names

                setActiveMunicipalities(_activeMunicipalities);

                if (props.type === 'vlaanderen') {
                  setMunicipalities(municipalitiesFiltered);
                } else {
                  setMunicipalities(props.MyCity ? mijn_stad_gemeente_municipalitiesData : municipalitiesData);
                }

                provincesFiltered = {
                  type: "FeatureCollection",
                  features: provincesData.features.filter(function (feature) {
                    return feature.properties.NameNL === 'Limburg' || feature.properties.NameNL === 'Oost-Vlaanderen' || feature.properties.NameNL === 'West-Vlaanderen' || feature.properties.NameNL === 'Vlaams-Brabant' || feature.properties.NameNL === 'Antwerpen' || feature.properties.NameNL === 'Brussels Hoofdstedelijk Gewest';
                  })
                };

                if (props.type === 'vlaanderen') {
                  setProvinces(provincesFiltered);
                } else {
                  setProvinces(provincesData);
                }
                setNisCodeLoaded(true);
              } catch (error) {
                console.error("Error loading data:", error);
              } finally {
                setLoading(false); // Set loading to false after data is loaded
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function getInitialData() {
      return _ref.apply(this, arguments);
    };
  }();

  // Get the remaining data only when selected on checkbox
  // const getOtherData = async (name) => {
  //   await axios.get(`https://o-sn.be/kml/belgium/${name === 'districts' ? 'arrondissementen' : name}.min.json`)
  //     .then((res) => {
  //       if (name === 'regions') {
  //         let new_object = {
  //           type: "FeatureCollection",
  //           features: res.data.features.filter(
  //             feature => feature.properties.NIS_code === '04000' || feature.properties.NIS_code === '02000')
  //         }
  //         if (props.type === 'vlaanderen') {
  //           setRegions(new_object)
  //         }
  //         else {
  //           setRegions(res.data)
  //         }
  //       }
  //       else if (name === 'provinces') { setProvinces(res.data) }
  //       else if (name === 'districts') {
  //         console.log(res.data)
  //         let new_object = {
  //           type: "FeatureCollection",
  //           features: res.data.features.filter(
  //             feature =>
  //               feature.properties.name === "BRUGGE (31000)" || feature.properties.name === "DIKSMUIDE (32000)"
  //               || feature.properties.name === "IEPER (33000)" || feature.properties.name === 'KORTRIJK (34000)'
  //               || feature.properties.name === "OOSTENDE (35000)" || feature.properties.name === 'ROESELARE (36000)'
  //               || feature.properties.name === "TIELT (37000)" || feature.properties.name === 'VEURNE (38000)'
  //               || feature.properties.name === "AALST (41000)" || feature.properties.name === 'DENDERMONDE (42000)'
  //               || feature.properties.name === "EEKLO (43000)" || feature.properties.name === 'GENT (44000)'
  //               || feature.properties.name === "OUDENAARDE (45000)" || feature.properties.name === 'SINT-NIKLAAS (46000)'
  //               || feature.properties.name === "ANTWERPEN (11000)" || feature.properties.name === 'MECHELEN (12000)'
  //               || feature.properties.name === "TURNHOUT" || feature.properties.name === 'HASSELT (71000)'
  //               || feature.properties.name === "MAASEIK (72000)" || feature.properties.name === 'TONGEREN'
  //               || feature.properties.name === "VOEREN" || feature.properties.name === 'Brussel Hoofdstad (21000)'
  //               || feature.properties.name === "HALLE-VILVOORDE (23000)" || feature.properties.name === 'LEUVEN (24000)'
  //           )
  //         }
  //         if (props.type === 'vlaanderen') {
  //           setArrondissementen(new_object)
  //         }
  //         else {
  //           setArrondissementen(res.data)
  //         }
  //       }
  //       else {
  //         let new_object = {
  //           type: "FeatureCollection",
  //           features: res.data.features.filter(
  //             feature =>
  //               feature.properties.NIS_3 === 'Limburg' || feature.properties.NIS_3 === 'Oost-Vlaanderen'
  //               || feature.properties.NIS_3 === 'West-Vlaanderen' || feature.properties.NIS_3 === 'Vlaams-Brabant'
  //               || feature.properties.NIS_3 === 'Antwerpen' || feature.properties.NIS_3 === 'Brussels Hoofdstedelijk Gewest'
  //           )
  //         }
  //         if (props.type === 'vlaanderen') {
  //           setSubMunicipalities(new_object)
  //         }
  //         else {
  //           setSubMunicipalities(res.data)
  //         }
  //       }
  //     })
  // }

  var getOtherData = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(name) {
      var regionsFiltered, districtsFiltered, subMunicipalitiesFiltered;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (name === 'regions') {
                regionsFiltered = {
                  type: "FeatureCollection",
                  features: regionsData.features.filter(function (feature) {
                    return feature.properties.NIS_code === '04000' || feature.properties.NIS_code === '02000';
                  })
                };

                if (props.type === 'vlaanderen') {
                  setRegions(regionsFiltered);
                } else {
                  setRegions(regionsData);
                }
              } else if (name === 'provinces') {
                setProvinces(provincesData);
              } else if (name === 'districts') {
                districtsFiltered = {
                  type: "FeatureCollection",
                  features: municipalitiesData.features.filter(function (feature) {
                    return feature.properties.name === "BRUGGE (31000)" || feature.properties.name === "DIKSMUIDE (32000)" || feature.properties.name === "IEPER (33000)" || feature.properties.name === 'KORTRIJK (34000)' || feature.properties.name === "OOSTENDE (35000)" || feature.properties.name === 'ROESELARE (36000)' || feature.properties.name === "TIELT (37000)" || feature.properties.name === 'VEURNE (38000)' || feature.properties.name === "AALST (41000)" || feature.properties.name === 'DENDERMONDE (42000)' || feature.properties.name === "EEKLO (43000)" || feature.properties.name === 'GENT (44000)' || feature.properties.name === "OUDENAARDE (45000)" || feature.properties.name === 'SINT-NIKLAAS (46000)' || feature.properties.name === "ANTWERPEN (11000)" || feature.properties.name === 'MECHELEN (12000)' || feature.properties.name === "TURNHOUT" || feature.properties.name === 'HASSELT (71000)' || feature.properties.name === "MAASEIK (72000)" || feature.properties.name === 'TONGEREN' || feature.properties.name === "VOEREN" || feature.properties.name === 'Brussel Hoofdstad (21000)' || feature.properties.name === "HALLE-VILVOORDE (23000)" || feature.properties.name === 'LEUVEN (24000)';
                  })
                };

                if (props.type === 'vlaanderen') {
                  setArrondissementen(districtsFiltered);
                } else {
                  setArrondissementen(districtsFiltered);
                }
              } else {
                subMunicipalitiesFiltered = {
                  type: "FeatureCollection",
                  features: (props.MyCity ? mijn_stad_gemeente_municipalitiesData : municipalitiesData).features.filter(function (feature) {
                    return feature.properties.NIS_3 === 'Limburg' || feature.properties.NIS_3 === 'Oost-Vlaanderen' || feature.properties.NIS_3 === 'West-Vlaanderen' || feature.properties.NIS_3 === 'Vlaams-Brabant' || feature.properties.NIS_3 === 'Antwerpen' || feature.properties.NIS_3 === 'Brussels Hoofdstedelijk Gewest';
                  })
                };

                if (props.type === 'vlaanderen') {
                  setSubMunicipalities(subMunicipalitiesFiltered);
                } else {
                  setSubMunicipalities(props.MyCity ? mijn_stad_gemeente_municipalitiesData : sub_MunicipalitiesData);
                }
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function getOtherData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  // const mouseOverHandler = async (feature, layer) => {
  //   // if (feature.properties.active === 'true') {
  //   //   layer.setStyle(props.MyCity ? catalogus_municialityStyle.style_active_hover : municialityStyle.style_active_hover)
  //   // }
  //   // else { layer.setStyle(props.MyCity ? catalogus_municialityStyle.style_hover : municialityStyle.style_hover) }
  // }
  // const mouseOutHandler = async (feature, layer) => {
  //   if (feature.properties.active === 'true') {
  //     layer.setStyle(props.MyCity ? catalogus_municialityStyle.style_active : municialityStyle.style_active)
  //   }
  //   else { layer.setStyle(props.MyCity ? catalogus_municialityStyle.style : municialityStyle.style) }
  // }

  var _checkboxHandler = function _checkboxHandler(border, index) {
    var copy = [].concat((0, _toConsumableArray3.default)(borders));
    // If it's not already active, load them in first
    if (!copy[index].loaded) {
      getOtherData(border.name);
      copy[index].loaded = true;
    }
    // otherwise, play with css to make them (in)visible
    else {

        var layers = document.getElementsByClassName(border.name);
        for (var i = 0; i < layers.length; i++) {
          if (copy[index].active) {
            layers[i].classList.add('hidden');
          } else {

            layers[i].classList.remove('hidden');
          }
        }
      }
    copy[index].active = !copy[index].active;
    setBorders(copy);
  };

  var onEachFeature = function onEachFeature(feature, layer) {
    var loggedIn = props.loggedIn;
    var followstate = props.followState;
    var fprops = feature.properties;
    if (fprops.Language === 'NL / FR') {
      fprops.Language = props.lang.toUpperCase();
    }
    // if (fprops.active === 'true') { layer.setStyle(props.MyCity ? catalogus_municialityStyle.style_active : municialityStyle.style_active) }

    // if (fprops && fprops.NameNL && fprops.NameNL == "Aalst") debugger;

    // if (loggedIn && followstate) {
    //   if (props.followingMunicipalities && props.followingMunicipalities.includes(fprops.NIS_code)) {
    //     // Mark it as active and apply the active style
    //     layer.setStyle(props.MyCity ? stad_gemeenteStyle.style_active : municialityStyle.style_active);
    //   }
    // }
    if (fprops.active === 'true') {
      // Apply the default style for inactive municipalities
      layer.setStyle(props.MyCity ? catalogus_municialityStyle.style_active : municialityStyle.style_active);
    }

    // to display the mapinfo when hovering and not when out
    var mapInfo = document.getElementById('mapInfo');

    // get the proper base url based on the languages
    var BASEURL = '';
    // if (fprops.Language === 'DE' && props.lang === 'nl') { BASEURL = '100procentlokaal.be' }
    // else if (fprops.Language === 'DE' && props.lang === 'fr') { BASEURL = '100pourcentlocale.be' }
    // else if (props.lang === 'nl' && fprops.Language === 'NL' && (fprops.NameNL === fprops.NameFR)) { BASEURL = '100procentlokaal.be' }
    // else if (props.lang === 'nl' && fprops.Language === 'NL' && (fprops.NameNL !== fprops.NameFR)) { BASEURL = '100procentlokaal.be' }
    // else if (props.lang === 'nl' && fprops.Language === 'FR' && (fprops.NameNL === fprops.NameFR)) { BASEURL = '100pourcentlocale.be' }
    // else if (props.lang === 'nl' && fprops.Language === 'FR' && (fprops.NameNL !== fprops.NameFR)) { BASEURL = '100procentlokaal.be' }

    // else if (props.lang === 'fr' && fprops.Language === 'FR' && (fprops.NameNL === fprops.NameFR)) { BASEURL = '100pourcentlocale.be' }
    // else if (props.lang === 'fr' && fprops.Language === 'FR' && (fprops.NameNL !== fprops.NameFR)) { BASEURL = '100pourcentlocale.be' }
    // else if (props.lang === 'fr' && fprops.Language === 'NL' && (fprops.NameNL === fprops.NameFR)) { BASEURL = '100procentlokaal.be' }
    // else if (props.lang === 'fr' && fprops.Language === 'NL' && (fprops.NameNL !== fprops.NameFR)) { BASEURL = '100pourcentlocale.be' }
    if (props.lang === 'nl') {
      BASEURL = '100procentlokaal.be';
    } else {
      BASEURL = '100pourcentlocale.be';
    }

    setBaseUrl(BASEURL);
    var municipalityName = fprops["Name" + props.lang.toUpperCase()].toLowerCase()
    // .replace('â', 'a')
    .replace(" (stad)", '').replace(" (ville)", '').replace(" (stadt)", '').replace(" city", '').replace(/\ /g, '').replace("'", '').replace("lalouviere", "la louvière").replace("lacalamine", "la calamine").replace("labruyere", "la-bruyere").replace("lahulpe", "la hulpe").replace("fontaine-l'évêque", 'fontaine-levêque');
    if (municipalityName === 'sgravenbrakel') {
      municipalityName = 's-gravenbrakel';
    }
    if (municipalityName === 'mont-de-lenclus') {
      municipalityName = 'montdelenclus';
    }
    if (municipalityName === 'lesbonsvillers') {
      municipalityName = 'les-bons-villers';
    }

    if (props.MyCity) {
      layer.bindTooltip("" + fprops["Name" + props.lang.toUpperCase()], { direction: 'top' });
    } else {
      layer.bindTooltip(municipalityName + "." + BASEURL, { direction: 'top' });
    }

    layer.on({
      'click': function click() {
        // window.open(`https://${fprops.PostalCode}.${BASEURL}`)
        props.getData ? props.getData(fprops) : window.open("https://" + municipalityName + "." + BASEURL);
      },

      'mouseover': function mouseover() {
        // mouseOverHandler(feature, layer)
        setCurrent(fprops.PostalCode + '|' + fprops["Name" + props.lang.toUpperCase()]);
        mapInfo.style.display = 'flex';
        layer.openTooltip();
      },
      'mouseout': function mouseout() {
        // mouseOutHandler(feature, layer)
        mapInfo.style.display = 'none';
      }
    });
  };

  return _react2.default.createElement(
    "div",
    { className: "percentlocal_wrapper", style: { display: 'flex', height: '100vh' } },
    showSidebar && props.getData ? _react2.default.createElement(_Sidebar2.default, {
      borders: borders,
      lang: props.lang,
      loggedIn: props.loggedIn,
      checkboxHandler: function checkboxHandler(border, index) {
        return _checkboxHandler(border, index);
      },
      setBaseLayer: function setBaseLayer(e) {
        return _setBaseLayer(e);
      },
      setBaseNames: function setBaseNames(e) {
        return _setBaseNames(e);
      },
      baseLayer: baseLayer,
      baseNames: baseNames,
      baseUrl: baseUrl,
      MyCity: props.MyCity,
      getData: function getData(e) {
        return props.getData(e);
      },
      login: function login(e) {
        return props.login(e);
      },
      type: props.type,
      hideLoginButton: props.hideLoginButton,
      followState: props.followState,
      hasCollaborationMunicipalityNames: activeMunicipalities
    }) : _react2.default.createElement(_Sidebar2.default, {
      borders: borders,
      lang: props.lang,
      checkboxHandler: function checkboxHandler(border, index) {
        return _checkboxHandler(border, index);
      },
      setBaseLayer: function setBaseLayer(e) {
        return _setBaseLayer(e);
      },
      setBaseNames: function setBaseNames(e) {
        return _setBaseNames(e);
      },
      baseLayer: baseLayer,
      baseNames: baseNames,
      baseUrl: baseUrl,
      MyCity: props.MyCity,
      login: function login(e) {
        return props.login(e);
      },
      type: props.type
    }),
    _react2.default.createElement(
      "div",
      { id: "mapInfo", className: "" + (props.MyCity ? 'myCity' : '') },
      _react2.default.createElement(_idbReactIconlib2.default, { name: "Mapmarker" }),
      _react2.default.createElement(
        "p",
        null,
        current
      )
    ),
    loading && !nisCodeLoaded ? _react2.default.createElement(
      "div",
      { className: "loader-container" },
      _react2.default.createElement("div", { className: "loader" })
    ) : _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        _reactLeaflet.Map,
        { style: { height: "100vh", width: '100%' }, zoom: 9, center: props.type === 'vlaanderen' ? [51, 4.25] : [50.75, 4.58], zoomControl: false, ref: mapRef },
        _react2.default.createElement(_reactLeaflet.ZoomControl, { position: "bottomright" }),
        _react2.default.createElement(_reactLeaflet.TileLayer, {
          attribution: "\xA9 <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
          url: baseLayer ? 'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png' : ''
        }),
        _react2.default.createElement(_reactLeaflet.TileLayer, {
          attribution: "\xA9 <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
          url: baseNames ? 'https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png' : ''
        }),
        country &&
        // By using Panes, I can define the order with Zindex, because we can't give Z-index to svg elements
        _react2.default.createElement(
          _reactLeaflet.Pane,
          { style: { zIndex: 406 } },
          _react2.default.createElement(_reactLeaflet.GeoJSON, {
            style: props.MyCity ? catalogus_countryStyle.style : countryStyle.style,
            data: country.features
          })
        ),
        regions && _react2.default.createElement(
          _reactLeaflet.Pane,
          { style: { zIndex: 405 } },
          _react2.default.createElement(_reactLeaflet.GeoJSON, {
            style: regionStyle.style,
            data: regions.features
          })
        ),
        provinces && _react2.default.createElement(
          _reactLeaflet.Pane,
          { style: { zIndex: 404 } },
          _react2.default.createElement(_reactLeaflet.GeoJSON, {
            style: props.MyCity ? catalogus_provinceStyle.style : provinceStyle.style,
            data: provinces.features
          })
        ),
        arrondissementen && _react2.default.createElement(
          _reactLeaflet.Pane,
          { style: { zIndex: 403 } },
          _react2.default.createElement(_reactLeaflet.GeoJSON, {
            style: arrondissementenStyle.style,
            data: arrondissementen.features
          })
        ),
        municipalities && _react2.default.createElement(
          _reactLeaflet.Pane,
          { style: { zIndex: 402 } },
          _react2.default.createElement(_reactLeaflet.GeoJSON, {
            style: municialityStyle.style,
            data: municipalities.features,
            onEachFeature: onEachFeature
          })
        ),
        subMunicipalities && _react2.default.createElement(
          _reactLeaflet.Pane,
          { style: { zIndex: 401 } },
          _react2.default.createElement(_reactLeaflet.GeoJSON, {
            style: submunicialityStyle.style,
            data: subMunicipalities.features
          })
        )
      )
    )
  );
};

exports.default = MyMap;